import { Navigate, Route, Routes } from "react-router-dom";
import { Dashboard } from "../pages/dashboard";
import { Login } from "../pages/login";
import { AdminLayout } from "../layouts/admin";
import ChatInterface from "../pages/chatInterface";
import CartInterface from "../pages/cartInterface";
import Result from "../pages/result";
import { SignUp } from "../pages/sign-up";
import { ConfirmSignUp } from "../pages/confirm-sign-up";
import { Report } from "../pages/report";
import { AdsSetting } from "../pages/ads-setting";
export function AppRoutes() {
  return (
    <Routes>
      <Route index element={<Navigate to="/dashboard" replace />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/report" element={<Report />} />
      <Route path="/admin" element={<AdsSetting />} />
      <Route path="/login" element={<Login />} />
      <Route path="/sign-up" element={<SignUp />} />
      <Route path="/confirm-sign-up" element={<ConfirmSignUp />} />
      {/* <Route path="/admin" element={<AdminLayout />}>
        <Route path="chat" element={<ChatInterface />} />
        <Route path="cart" element={<CartInterface />} />
        <Route path="result" element={<Result />} />
      </Route> */}
    </Routes>
  );
}
